import {createSlice} from '@reduxjs/toolkit';
import {createSelector} from 'reselect';
import {getUrlParameterByName} from 'contexts/openIdConnect';

export const appSlice = createSlice({
  name: 'app',
  initialState: {
    accessToken: getUrlParameterByName('access_token'),
    accessTokenIsAvailable: false,
    accessTokenExpiration: getUrlParameterByName('expires_in'),
    accessTokenType: getUrlParameterByName('token_type'),
    loginDateTime: undefined,
    authError: {is: false},
    config: {},
    userInfo: {},
    rights: undefined
  },
  reducers: {
    setAccessTokenIsAvailable: (state, action) => {
      state.accessTokenIsAvailable = action.payload;
    },
    setLoginDateTime: (state, action) => {
      state.loginDateTime = action.payload;
    },
    setAuthError: (state, action) => {
      state.authError = action.payload;
    },
    setConfig: (state, action) => {
      state.config = action.payload;
    },
    setUserInfo: (state, action) => {
      state.userInfo = action.payload;
    },
    setRights: (state, action) => {
      state.rights = action.payload;
    }
  }
});

export const {setAccessTokenIsAvailable, setLoginDateTime, setAuthError, setConfig, setUserInfo, setRights} =
  appSlice.actions;

const appDataSelector = (state) => state.app;

export const accessTokenSelector = createSelector([appDataSelector], (appData) => appData.accessToken);
export const accessTokenIsAvailableSelector = createSelector(
  [appDataSelector],
  (appData) => appData.accessTokenIsAvailable
);
export const accessTokenExpirationSelector = createSelector(
  [appDataSelector],
  (appData) => appData.accessTokenExpiration
);
export const accessTokenTypeSelector = createSelector([appDataSelector], (appData) => appData.accessTokenType);
export const loginDateTimeSelector = createSelector([appDataSelector], (appData) => appData.loginDateTime);
export const authErrorSelector = createSelector([appDataSelector], (appData) => appData.authError);
export const configSelector = createSelector([appDataSelector], (appData) => appData.config);
export const userInfoSelector = createSelector([appDataSelector], (appData) => appData.userInfo);
export const rightsSelector = createSelector([appDataSelector], (appData) => appData.rights);

export default appSlice.reducer;
